import Smedias from "../pages/smedias.vue"

export const SmediasRoutes = [{
  path: "/smedias",
  name: "لیست  شبکه‌های اجتماعی",
  component: Smedias,
}
];
export default SmediasRoutes;
